export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

export namespace URLs {
  export const LOADER_CDN_URL = `${import.meta.env.VITE_CDN_URL}/coupon-builder/cx/loader.js`
  export const JAMS_BACKEND_URL = import.meta.env.VITE_JAMS_BACKEND_URL
  export const COUPONS_API_URL = import.meta.env.VITE_COUPONS_API_URL
  export const CX_URL = import.meta.env.VITE_CX_URL
}
